import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { AmountBOA } from "../common/amountBOA";
import { useLocation, withRouter } from "react-router-dom";
import { mapStateToProps, mapDispatchToProps } from "../../actions/addresses";
import { showMsg } from "../../actions/alertAction";
import * as sdk from "boa-sdk-ts";
import { amountFormat, getPayloadFee } from "../../utils/WalletUtils";
import { WalletMA } from "boa-sdk-ts";
import Address from "../common/address";

const TransactionDetails = (props) => {
  const dispatch = useDispatch();
  const { t } = props;
  const [transactionOverview, setTransactionOverview] = useState();
  const [txHash, setTxHash] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      const tx_hash = location.state.tx_hash;
      if (tx_hash) {
        getTransactionDetails(tx_hash);
      }
    } else {
      props.history.push("/");
    }
  }, []);

  const getTransactionDetails = async (tx_hash) => {
    const { client } = WalletMA.instance();
    setTxHash(tx_hash);
    const txHash = new sdk.Hash(tx_hash);
    const res = await client.getTransactionDetail(txHash);
    if (res.code === sdk.WalletResultCode.Success) {
      if (res.data !== undefined) {
        setTransactionOverview(res.data);
      } else {
        dispatch(showMsg(t("Something_went_wrong")));
      }
    } else {
      dispatch(showMsg(t("Something_went_wrong")));
    }
  };

  return (
    <div className="Content">
      <div className="TableBg cardBg">
        <div className="ContHeader">
          <h1 className="OverviewTitle"> {t("Transaction_Details")}</h1>
        </div>

        {txHash && (
          <>
            <div className="ContHeader">
              <h3>txHash</h3>
            </div>
            <div className="data-value">
              <p>{txHash}</p>
            </div>
          </>
        )}

        <div className="ContHeader">
          <h3>{t("Senders_Detail")}</h3>
        </div>
        {/* Senders Detail section */}
        <div className="table-responsive trans-detail-table">
          <table className="table">
            <thead className="tableHead">
              <tr>
                <th>
                  <p>{t("Address")} </p>
                </th>
                <th>
                  <p>{t("UTXO")} </p>
                </th>
                <th>
                  <p className="amount">{t("Amount")} </p>
                </th>
              </tr>
            </thead>
            {transactionOverview && transactionOverview.senders.length === 0 ? (
              <tbody className="tablebody tbody1">
                <tr className="noData">
                  <td className="inner">
                    <h3 className="text-center mb-3">{t("sorry_no_data")}</h3>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="tablebody tbody1">
                {transactionOverview &&
                  transactionOverview.senders.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <Address
                          className="purpleText"
                          address={info.address}
                        />
                      </td>
                      <td>
                        <Address
                          className="address-copy purpleText"
                          address={info.utxo}
                          isCopy={true}
                        />
                      </td>
                      <td className="amount">
                        <AmountBOA
                          amount={info.amount}
                          className="amount_align rPadding20"
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>
        <div className="ContHeader">
          <h3>{t("Receivers_Detail")}</h3>
        </div>
        {/* Receivers Detail section */}
        <div className="table-responsive trans-detail-table">
          <table className="table">
            <thead className="tableHead">
              <tr>
                <th> {t("Address")}</th>
                <th> {t("UTXO")}</th>
                <th>
                  <p className="amount">{t("Amount")}</p>{" "}
                </th>
              </tr>
            </thead>
            {transactionOverview &&
            transactionOverview.receivers.length === 0 ? (
              <tbody className="tablebody tbody2">
                <tr className="noData">
                  <td className="inner">
                    <h3 className="text-center mb-3">{t("sorry_no_data")}</h3>
                  </td>
                </tr>
              </tbody>
            ) : (
              <tbody className="tablebody tbody2">
                {transactionOverview &&
                  transactionOverview.receivers.map((info, index) => (
                    <tr key={index}>
                      <td>
                        <Address
                          className="purpleText"
                          address={info.address}
                        />
                      </td>
                      <td>
                        <Address
                          className="address-copy purpleText"
                          address={info.utxo}
                          isCopy={true}
                        />
                      </td>
                      <td>
                        <AmountBOA
                          className="amount_align rPadding20"
                          amount={info.amount}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
          </table>
        </div>
        {transactionOverview && transactionOverview?.payload && (
          <>
            <div className="ContHeader">
              <h3>{t("Payload")}</h3>
            </div>
            <div className="data-value">
              <p>{transactionOverview.payload.toString("base64")}</p>
            </div>
          </>
        )}
        {transactionOverview && transactionOverview?.fee && (
          <>
            <div className="ContHeader">
              <h3>{t("Transaction_Fee")}</h3>
            </div>
            <div className="data-value">
              <p>{amountFormat(transactionOverview.fee)} BOA</p>
            </div>
          </>
        )}
        {transactionOverview &&
          transactionOverview?.freezing_fee &&
          parseInt(transactionOverview.freezing_fee) > 0 && (
            <>
              <div className="ContHeader">
                <h3>{t("Freezing_Fee")}</h3>
              </div>
              <div className="data-value">
                <p>{amountFormat(transactionOverview.freezing_fee)} BOA</p>
              </div>
            </>
          )}
        {transactionOverview?.payload && transactionOverview.payload_fee && (
          <>
            <div className="ContHeader">
              <h3>{t("Payload_Fee")}</h3>
            </div>
            <div className="data-value">
              <p>
                {amountFormat(transactionOverview?.payload_fee)}
                {" BOA"}
              </p>
            </div>
          </>
        )}
        <div className="OverviewBtns">
          <button
            className="btn btn-default ConfirmBtnSmall"
            onClick={() => props.history.goBack()}
          >
            {" "}
            {t("Previous")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(TransactionDetails))
);
